import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { AddItemFormData } from '../../../hooks/use-add-item-form';
import { SectionHeader } from '../section-header';

export function NonComplianceStep() {
  const { t } = useTranslation('goodsReceiving');
  const { control } = useFormContext<AddItemFormData>();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <SectionHeader title={t('nonComplianceSectionTitle')} />
      <Controller
        name="isDamaged"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox checked={field.value || false} onChange={field.onChange} />}
            label={t('isDamaged')}
          />
        )}
      />
      <Controller
        name="isTemperatureNonCompliant"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox checked={field.value || false} onChange={field.onChange} />}
            label={t('isTemperatureNonCompliant')}
          />
        )}
      />
      <Controller
        name="isHygieneNonCompliant"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox checked={field.value || false} onChange={field.onChange} />}
            label={t('isHygieneNonCompliant')}
          />
        )}
      />
    </Box>
  );
}
